module.exports = __webpack_public_path__ + "cuttingline5.png?b321b58192cf43499597406d6e106000";